export const RESOURCE_STATUS_NOT_LOADED = 'not_loaded';
export const RESOURCE_STATUS_LOADING    = 'loading';
export const RESOURCE_STATUS_LOADED     = 'loaded';
export const GENDER_MALE                = 'male';
export const GENDER_FEMALE              = 'female';

export const PERIOD_ALL          = 'all';
export const PERIOD_LAST_30_DAYS = 'last_30_days';
export const PERIOD_LAST_7_DAYS  = 'last_7_days';
export const PERIOD_YESTERDAY    = 'yesterday';
export const PERIOD_TODAY        = 'today';
